import AxiosClient from "../../../services/axios.services";

class LevelServices {
  getLevel = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_niveles/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getLevelById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_niveles/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveLevel = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_niveles/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editLevel = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_niveles/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteLevel = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_niveles/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new LevelServices();
